import http from './https';

// 测试接口
export function getTestApiRequest(params) {
    return http.get(`/api/test/hello`, params);
}


// 获取微信初始化参数
export function getWeChatInitConfigRequest(params) {
    return http.get(`/api/general/jsapi-signature`, params);
}

// 获取注册登录验证码
export function getRegisterLoginSmsCodeRequest(params) {
    return http.post(`/api/auth/send-code`, params);
}

// 登录
export function setRegisterLoginRequest(params) {
    return http.post(`/api/auth/login`, params);
}


// 获取项目地
export function getBuildingNamesRequest(params) {
    return http.get(`/api/rooms/buildingNames`, params);
}
// 获取项目地的楼层
export function getBuildingFloorsRequest(params) {
    return http.get(`/api/rooms/floors`, params);
}
// 获取其他管理员信息
export function getOtherNormalAdminRequest(params) {
    return http.get(`/api/admins/listAllNormalAdmin`, params);
}
// 上传会议室图片
export function uploadFileRequest(formData) {
    return http.postForm(`/api/admins/upload`, formData);
}
// 创建会议室
export function saveMeetingRoomRequest(params) {
    return http.post(`/api/admins/rooms`, params);
}
// 获取我负责的会议室列表（当前用户为管理员）
export function getMyMeetingRoomsRequest(params) {
    return http.get(`/api/admins/listAllAdminRooms`, params);
}

// 获取会议室当前预约信息（当前用户为普通用户）
export function getRoomInfoRequest(params) {
    return http.get(`/api/rooms/roomInfo`, params);
}

// 获取会议室当前预约信息（当前用户为普通用户）
export function searchRoomsRequest(params) {
    return http.get(`/api/rooms/searchRoom`, params);
}

// 预约会议室 body参数  roomId， startTime， endTime  格式为yyyy-MM-dd HH:mm:ss, 系统只获取到 yyyy-MM-dd HH 的信息
export function createReservationRequest(params) {
    return http.post(`/api/reservations/create`, params);
}


// 获取会议室当前预约信息（当前用户为普通用户）
export function getReservationListRequest(params) {
    return http.get(`/api/reservations/list`, params);
}
// 取消预约
export function cancelReservationRequest(params) {
    return http.get(`/api/reservations/cancel`, params);
}
// 开门请求
export function openDoorRequest(params) {
    return http.get(`/api/reservations/open`, params);
}

// 审核会议室列表
export function getReservationsRequest(params) {
    return http.get(`/api/admins/reservations`, params);
}
// 审核通过
export function getApproveReservationRequest(params) {
    return http.get(`/api/admins/approveReservation`, params);
}
// 审核不通过
export function getRejectReservationRequest(params) {
    return http.get(`/api/admins/rejectReservation`, params);
}

// 管理员开门
export function adminOpenDoorRequest(params) {
    return http.get(`/api/admins/openRoom`, params);
}